<template>
  <div id="search">
    <el-button
      id="search-button"
      type="primary"
      :disabled="!canTakeRes"
      @click='searchAvailability'>
        Search for Availability <span v-if="!canTakeRes">- Choose Another Date/Time.</span>
    </el-button>
  </div>
</template>

<script>
export default {
  name: 'buttonSearch',
  computed: {
    canTakeRes() {
      let firstTimeslot = this.$store.state.availability.firstTimeslot
      let lastTimeslot = this.$store.state.availability.lastTimeslot
      
      if ( parseFloat( firstTimeslot ) >= parseFloat( lastTimeslot ) ) {
        return false
      }

      
      if ( this.$store.state.availability.location == null ) {
        return false
      }

      return true
    },
  },
  methods: {
    searchAvailability() {
      this.$emit( 'searchAvailability' )
    }
  }
}

</script>

<style lang="scss" scoped>

#search {
  margin-left: auto;
  margin-right: auto;
  text-align: center;
}

#search-button {
  width: 95%;
  margin-top: 20px;

  @media screen and (max-width: 768px) {
    width: 100%;
  }
}
</style>